module.exports = __webpack_public_path__ + "static/img/wireframe-img-01@t.0fd96fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/serveone/wireframe-img-01@t.png
// module id = pB6g
// module chunks = 0